"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDirectoryWrapped = exports.resolveModuleWrapped = void 0;
const modules_1 = require("../../sandbox/modules");
Object.defineProperty(exports, "resolveModuleWrapped", { enumerable: true, get: function () { return modules_1.resolveModuleWrapped; } });
Object.defineProperty(exports, "resolveDirectoryWrapped", { enumerable: true, get: function () { return modules_1.resolveDirectoryWrapped; } });
